<template>
    <section class="search">
      <div class="container">
          <form class="row" @submit.prevent="sendForm()">
              <div class="col-lg-4 col-md-6 col-12 mx-auto">
                  <div class="d-flex flex-column gap-2 mb-1">
                      <label for="reservationNumber">ادخل رقم هاتف الطالب</label>
                      <InputMask id="studentPhone" inputId="integeronly" mask="99999999999" :useGrouping="false" v-model="student_phone" aria-describedby="studentPhone-help" />
                      <span class="text-danger" v-if="v$.student_phone.$error">برجاء ادخال رقم هاتف الطالب</span>
                  </div>
                  <button type="submit" class="btn primaryButton w-100 mt-4" :disabled="formSending"><i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i> {{ formSending ? 'جاري الارسال...' : 'إرسال' }}</button>
              </div>
          </form>
      </div>
    </section>
  </template>
  
  <script>
import InputMask from 'primevue/inputmask';
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import axios from 'axios';
  import Swal from 'sweetalert2';
  
  export default {
      name: "search-page",
      components: {
        InputMask
      },
      data() {
          return {
            v$: useVuelidate(),
            student_phone: null,
            formSending: false
          }
      },
      validations() {
          return {
            student_phone: { required },
          };
      },
      methods: {
          sendForm() {
              this.v$.$validate();
              if (!this.v$.$error) {
                  const formData = new FormData();
                  formData.append('student_phone', this.student_phone);
                  this.formSending = true;
                  
                  axios
                      .post('/student_reservation', formData)
                      .then((response) => {
                          this.formSending = false;
                        //   console.log(response.data);
                          if(response.data.status == true) {
                              Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "رقم الحجز الخاص بك  " + response.data.data.reservation_id,
                              });
                          }
                          if(response.data.status == false) {
                              Swal.fire({
                                  position: "center",
                                  icon: "warning",
                                  title: response.data.message,
                              });
                          }
                      })
                      .catch((error) => {
                          this.formSending = false;
                          Swal.fire({
                              position: "center",
                              icon: "error",
                              title: error.response.data.message,
                          });;
                      });
              }
          }
      }
  }
  </script>
  
  <style>
  
  </style>